export enum FORM {
  CREATE_PROMPT = 'CREATE_PROMPT',
  UPDATE_PROMPT = 'UPDATE_PROMPT',
}
